import { Flex, Logo } from '@percent/lemonade';
import { Text } from '@mantine/core';

import styles from './Footer.module.scss';
import { Link } from 'react-router-dom';
import { PRIVACY_POLICY_URL } from '@percent/grants-nomination-form/constants/legalUrls';
import { useTranslation } from 'react-i18next';

export const GOODSTACK_URL = 'https://goodstack.io/';

const FooterLink = ({ children, to }: { children: React.ReactNode; to: string }) => {
  return (
    <Link to={to} className={styles.footerLink} target="_blank" rel="noopener noreferrer">
      <Text fz="xs" fw={500} c="#6A6D74">
        {children}
      </Text>
    </Link>
  );
};

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <Flex className={styles.footerWrapper}>
      <Flex align="center" gap={8}>
        <Text fz="xs" fw={500}>
          {/* We want to keep this without translation */}
          Powered by
        </Text>
        <Link to={GOODSTACK_URL} target="_blank" rel="noopener noreferrer">
          <Logo className={styles.logo} />
        </Link>
      </Flex>
      <Flex align="center" gap={4}>
        <FooterLink to={PRIVACY_POLICY_URL}>{t('typography.privacy')}</FooterLink>
      </Flex>
    </Flex>
  );
};
